var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowKpiUp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 13,
    viewBox: "0 0 10 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.29526 6.26497C1.01085 6.56611 0.536173 6.57967 0.235034 6.29526C-0.0661044 6.01085 -0.0796667 5.53617 0.204742 5.23503L4.45474 0.735033C4.59642 0.585016 4.79366 0.5 5 0.5C5.20635 0.5 5.40358 0.585016 5.54526 0.735033L9.79526 5.23503C10.0797 5.53617 10.0661 6.01085 9.76497 6.29526C9.46383 6.57967 8.98915 6.56611 8.70474 6.26497L5.75 3.13642V11.75C5.75 12.1642 5.41421 12.5 5 12.5C4.58579 12.5 4.25 12.1642 4.25 11.75V3.13642L1.29526 6.26497Z",
    fill: "#4DB595"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowKpiUp);
export default __webpack_public_path__ + "static/media/arrow-kpi-up.f5cbdae5.svg";
export { ForwardRef as ReactComponent };